import auth from './en/auth';
import about from './en/about';
import contact from './en/contact';
import configuration from './en/configuration';
import dashboard from './en/dashboard';
import home from './en/home';
import fields from './en/fields';
import footer from './en/footer';
import legal from './en/legal';
import markets from './en/markets';
import promo from './en/promo';
import portfolio from './en/portfolio';
import payments from './en/payments';
import config from './en/config';
import data from './en/data';

const messages = {
    en: {
        ...auth,
        ...about,
        ...contact,
        ...configuration,
        ...home,
        ...fields,
        ...footer,
        ...legal,
        ...markets,
        ...promo,
        ...dashboard,
        ...portfolio,
        ...payments,
        ...config,
        data,
    },
};

export default messages;
